<div class="loader-content">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="lds-ripple">
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</div>